import { CheckInCircleActive, CrossInFilledCircle } from "assets/icons";

import { PaymentMethodActivationMarkProps } from "../DeliveryFeesTable.types";

import styles from "../DeliveryFeesTable.module.scss";

const PaymentMethodActivationMark = ({
  isActiveCOD,
  isActiveMM
}: PaymentMethodActivationMarkProps) => {
  return (
    <div className={styles.paymentMethods}>
      {isActiveCOD ? (
        <CheckInCircleActive color={"#16C350"} />
      ) : (
        <CrossInFilledCircle fill={"#A8A8BB"} />
      )}
      {isActiveMM ? (
        <CheckInCircleActive color={"#16C350"} />
      ) : (
        <CrossInFilledCircle fill={"#A8A8BB"} />
      )}
    </div>
  );
};

export default PaymentMethodActivationMark;
